export default "__VITE_ASSET__DrsIzKjI__"